module.exports = __webpack_public_path__ + "static/media/icon_gestao.445a55c9.png";